// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"109":"de0f09e0","490":"97bb580a"}[chunkId] + ".chunk.css";
};